import React from 'react';
import './Grid.scss';

interface GridSkeletonProps {
  columns: number;
  rows?: number;
}

export const GridSkeleton: React.FC<GridSkeletonProps> = ({ columns, rows = 10 }) => {
  return (
    <div className="grid-skeleton">
      <table className="k-grid-table">
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex} className={rowIndex % 2 === 0 ? '' : 'k-alt'}>
              {[...Array(columns)].map((_, colIndex) => (
                <td key={colIndex} role="gridcell">
                  <div className="skeleton skeleton-text" style={{ width: `${Math.floor(Math.random() * 40) + 50}%` }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
